module.exports = __webpack_public_path__ + "img/25.87b8994d.jpg";